import { render, staticRenderFns } from "./MedicalInformation.vue?vue&type=template&id=3320e008"
import script from "./MedicalInformation.vue?vue&type=script&lang=js"
export * from "./MedicalInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports